const FULL_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ';
const CUSTOM_FORMAT = 'MMM D, YYYY h:mm:ss a';
export { CUSTOM_FORMAT, FULL_FORMAT };
